import { Size } from '../../../styles/theme.mjs';
import styled from 'styled-components';

const StyledButton = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  padding: ${props => {
    var _a, _b;
    return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.padding.md[props.isSymmetricalPadding ? 'symmetrical' : 'basic'];
}};
  gap: ${props => { var _a, _b; return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.gap; }};
  border-radius: 4px;
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  font-size: ${props => { var _a; return (_a = props.theme.interactive.button[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.fontSize; }};
  line-height: ${props => { var _a; return (_a = props.theme.interactive.button[props.size || Size.Regular]) === null || _a === void 0 ? void 0 : _a.lineHeight; }};
  text-transform: ${props => (props.uppercased ? 'uppercase' : 'none')};
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;

  svg {
    margin-bottom: 2px;
    transform: ${props => { var _a, _b; return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.transform; }};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.xl}) {
    padding: ${props => {
    var _a, _b;
    return (_b = props.theme.interactive.button[(_a = props.size) !== null && _a !== void 0 ? _a : Size.Regular]) === null || _b === void 0 ? void 0 : _b.padding.sm[props.isSymmetricalPadding ? 'symmetrical' : 'basic'];
}};
  }
`;
const StyledPrimaryButton = styled(StyledButton) `
  color: ${props => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.white; }};
  background-color: ${props => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : props.theme.colors.skyBlue; }};
  border: none;

  @media (pointer: fine) {
    &:hover:not(:disabled) {
      background-color: ${props => { var _a; return (_a = props.hoverColor) !== null && _a !== void 0 ? _a : props.theme.colors.skyBlueShade; }};
    }
  }
`;
const StyledSecondaryButton = styled(StyledButton) `
  color: ${props => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.white; }};
  background-color: ${props => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : props.theme.colors.darkGray; }};
  border: none;

  @media (pointer: fine) {
    &:hover:not(:disabled) {
      background-color: ${props => { var _a; return (_a = props.hoverColor) !== null && _a !== void 0 ? _a : props.theme.colors.darkGrayShade; }};
    }
  }
`;
const StyledOutlineButton = styled(StyledButton) `
  color: ${props => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.buttonTextColor; }};
  background-color: transparent;
  border: 2px solid ${props => { var _a; return (_a = props.borderColor) !== null && _a !== void 0 ? _a : props.theme.colors.skyBlue; }};

  @media (pointer: fine) {
    &:hover:not(:disabled) {
      box-shadow: 0px 0px 0px 1px ${props => { var _a; return (_a = props.hoverColor) !== null && _a !== void 0 ? _a : props.theme.colors.skyBlue; }} inset;
    }
  }
`;
const StyledLink = styled.a `
  all: unset;
`;

export { StyledButton, StyledLink, StyledOutlineButton, StyledPrimaryButton, StyledSecondaryButton };
//# sourceMappingURL=Button.styles.mjs.map
